import TtamMaterialUploadRequirement from './material-requirement/index.vue';
import TtamMaterialUploadSelectFileButton from './select-file-button/index.vue';

import TtamMaterialUploadTable from './material-table/index.vue';
import TtamMaterialUploadSelectTable from './material-table/select-table.vue';
import TtamMaterialUploadProgressTable from './material-table/progress-table.vue';

export default {
  TtamMaterialUploadRequirement,
  TtamMaterialUploadSelectFileButton,

  TtamMaterialUploadTable,
  TtamMaterialUploadSelectTable,
  TtamMaterialUploadProgressTable,
};
